import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";
import { storage } from "./storage.service";
import { storageKeys } from "../Constants/storage.key";

//const basePath = `${API_URLS.AUTH}/v3/Auth`;
const basePath = `${API_URLS.AUTH}/v3/Users`;
const basePathUsers = `${API_URLS.VEHICLE_V3}/vehicle-groups`;


export const usersService = {
  users,
  updateUser,
  passwordChange,
  byClient,
  usersChildren,
  fetchUsersByGroup,
  avatarUpload,
  fetchAvatarImage
};

async function users() {
  try {
    const response = await api.get(basePath);

    const treated = errorHandling.handleResponse(response, "userService.users");
    if (treated) {
      storage.save(storageKeys.user_data, treated);
      return treated;
    }
    return false;
  } catch (error) {
    errorHandling.cathError(error, "userService.users");
    return false;
  }
}

async function updateUser(payload) {
  try {
    const response = await api.put(basePath, payload);

    const treated = errorHandling.handleResponse(response, "userService.updateUser");
    if (treated) {
      storage.save(storageKeys.user_data, treated);
      return treated;
    }
    return false;
  } catch (error) {
    errorHandling.cathError(error, "userService.updateUser");
    return false;
  }
}

async function fetchAvatarImage() {
  
  try {
    const response = await api.get(`${basePath}/avatar`, {
      responseType: 'blob', 
    });

    return response.data; 
  } catch (error) {
    errorHandling.cathError(error, "userService.fetchAvatarImage");
    return false;
  }
}



async function avatarUpload(formData) {
  try {
    // NÃO serializar o FormData - deixar como está
    // Se seu api.patch() tem interceptor que serializa, desabilita para FormData
    const response = await api.patch(`${basePath}/avatar`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data' // Deixa o navegador setar automaticamente
      }
    });

    const treated = errorHandling.handleResponse(response, "userService.avatarUpload");
    if (treated) {
      storage.save(storageKeys.user_data, treated);
      return treated
    }
    return false;
  } catch (error) {
    errorHandling.cathError(error, "userService.avatarUpload");
    return false;
  }
}


async function usersChildren() {
  try {
    const response = await api.get(`${basePath}/children`);

    const treated = errorHandling.handleResponse(response, "userService.usersChildren");
    if (treated) {
      storage.save(storageKeys.user_data, treated);
      return treated
    }
    return false;
  } catch (error) {
    errorHandling.cathError(error, "userService.usersChildren");
    return false;
  }
}


async function passwordChange(payload) {
  try {
    const response = await api.put(`${basePath}/password/change`, payload);

    const treated = errorHandling.handleResponse(response, "userService.passwordChange");
    return treated;
  } catch (error) {
    errorHandling.cathError(error, "userService.passwordChange");
    return false;
  }
}

async function byClient() {
  
  try {
    const response = await api.get(`${basePath}/sons`);
    const treated = errorHandling.handleResponse(response, "userService.byClient");
    return treated;
  } catch (error) {
    errorHandling.cathError(error, "userService.byClient");
    return false;
  }
}

async function fetchUsersByGroup(groupIdParam) {
  const groupId = groupIdParam ?? 0

  try {
    const response = await api.get(`${basePathUsers}/user-vehicle-groups?vehicleGroupId=${groupId}`);

    const treated = errorHandling.handleResponse(response, "userService.fetchUsersByGroup");
    if (treated) {
      storage.save(storageKeys.user_data, treated);
      return treated
    }
    return false;
  } catch (error) {
    errorHandling.cathError(error, "userService.fetchUsersByGroup");
    return false;
  }
}